import "bootstrap";
import "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import "jquery-validation";
import { asterEndLoader, asterStartLoader, baseUrl, showError } from "./utils/commonUtils";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import "./modal_stacking_fix";

// import dtFR from "datatables.net-plugins/i18n/fr-FR.json";
// import { dt_fr_FR } from "./utils/locales";

/* $.fn.dataTable.ext.buttons.reload = {
    text: "<i class='fad fa-rotate-reverse'></i>",
    action(_e, dt) {
        dt.ajax.reload();
    },
};

$.fn.dataTable.ext.buttons.new = {
    text: "<i class='fa fa-plus'></i> Ajouter",
    action() {
        console.warn("Action à implémenter");
    },
}; */

dayjs.locale("fr");

$(".modal form").on("submit", (e) => {
    e.preventDefault();

    console.warn("Soumission du formulaire annulée");
});

$(document).on("ajaxSend", (_event, _response, request) => {
    if (["/view/", "/save.json"].some((text) => (request.url as string).includes(text))) {
        asterStartLoader();
    }
});
$(document).on("ajaxComplete", (_event, _response, settings) => {
    if (["/view/", "/save.json"].some((text) => (settings.url as string).includes(text))) {
        asterEndLoader();
    }
});

$(document).on("ajaxError", (_event, response, _request, description) => {
    if (description === "abort") {
        return;
    }

    asterEndLoader();
    console.info("ajax error", description);

    switch (response.status) {
        case 401:
            showError("Votre session a expiré, veuillez vous reconnecter");
            setTimeout(() => {
                window.location.href = `${baseUrl}users/login`;
            }, 5_000);
            break;
        case 500:
            // showError("Une erreur s'est produite sur le serveur");
            console.error(response);
            break;

        // Dans le cas où le serveur renvoie une réponse mais mal formatée
        // par exemple une erreur cake ou un retour avec des warnings
        case 200:
            // showError("Réponse du serveur impossible à lire");
            console.error(description);
            break;

        default:
            // Pour le moment on ne gère pas les erreurs inconnues
            // showError("Une erreur s'est produite");
            break;
    }
});

/* $.extend(true, $.fn.dataTable.defaults, {
    language: dt_fr_FR,
}); */

//Source -> https://github.com/jquery-validation/jquery-validation/blob/master/src/localization/messages_fr.js
$.extend($.validator.messages, {
    required: "Ce champ est obligatoire.",
    remote: "Veuillez corriger ce champ.",
    email: "Veuillez fournir une adresse électronique valide.",
    url: "Veuillez fournir une adresse URL valide.",
    date: "Veuillez fournir une date valide.",
    dateISO: "Veuillez fournir une date valide (ISO).",
    number: "Veuillez fournir un numéro valide.",
    digits: "Veuillez fournir seulement des chiffres.",
    creditcard: "Veuillez fournir un numéro de carte de crédit valide.",
    equalTo: "Veuillez fournir encore la même valeur.",
    notEqualTo: "Veuillez fournir une valeur différente, les valeurs ne doivent pas être identiques.",
    extension: "Veuillez fournir une valeur avec une extension valide.",
    maxlength: $.validator.format("Veuillez fournir au plus {0} caractères."),
    minlength: $.validator.format("Veuillez fournir au moins {0} caractères."),
    rangelength: $.validator.format("Veuillez fournir une valeur qui contient entre {0} et {1} caractères."),
    range: $.validator.format("Veuillez fournir une valeur entre {0} et {1}."),
    max: $.validator.format("Veuillez fournir une valeur inférieure ou égale à {0}."),
    min: $.validator.format("Veuillez fournir une valeur supérieure ou égale à {0}."),
    step: $.validator.format("Veuillez fournir une valeur multiple de {0}."),
    maxWords: $.validator.format("Veuillez fournir au plus {0} mots."),
    minWords: $.validator.format("Veuillez fournir au moins {0} mots."),
    rangeWords: $.validator.format("Veuillez fournir entre {0} et {1} mots."),
    letterswithbasicpunc: "Veuillez fournir seulement des lettres et des signes de ponctuation.",
    alphanumeric: "Veuillez fournir seulement des lettres, nombres, espaces et soulignages.",
    lettersonly: "Veuillez fournir seulement des lettres.",
    nowhitespace: "Veuillez ne pas inscrire d'espaces blancs.",
    ziprange: "Veuillez fournir un code postal entre 902xx-xxxx et 905-xx-xxxx.",
    integer: "Veuillez fournir un nombre non décimal qui est positif ou négatif.",
    vinUS: "Veuillez fournir un numéro d'identification du véhicule (VIN).",
    dateITA: "Veuillez fournir une date valide.",
    time: "Veuillez fournir une heure valide entre 00:00 et 23:59.",
    phoneUS: "Veuillez fournir un numéro de téléphone valide.",
    phoneUK: "Veuillez fournir un numéro de téléphone valide.",
    mobileUK: "Veuillez fournir un numéro de téléphone mobile valide.",
    strippedminlength: $.validator.format("Veuillez fournir au moins {0} caractères."),
    email2: "Veuillez fournir une adresse électronique valide.",
    url2: "Veuillez fournir une adresse URL valide.",
    creditcardtypes: "Veuillez fournir un numéro de carte de crédit valide.",
    currency: "Veuillez fournir une monnaie valide.",
    ipv4: "Veuillez fournir une adresse IP v4 valide.",
    ipv6: "Veuillez fournir une adresse IP v6 valide.",
    require_from_group: $.validator.format("Veuillez fournir au moins {0} de ces champs."),
    nifES: "Veuillez fournir un numéro NIF valide.",
    nieES: "Veuillez fournir un numéro NIE valide.",
    cifES: "Veuillez fournir un numéro CIF valide.",
    postalCodeCA: "Veuillez fournir un code postal valide.",
    pattern: "Format non valide.",
});
